import { OUTBOUND_STAGES, STAGE_LABEL } from "../../../domain/stages";
import { lazyList } from "../../../i18n/localized";

const DEFAULT_STAGES = lazyList(OUTBOUND_STAGES.length, (i) => STAGE_LABEL[OUTBOUND_STAGES[i]!]);

export function PipelineMini({
  index,
  state,
  stages = DEFAULT_STAGES,
}: {
  index: number;
  state?: "failed" | "running";
  stages?: readonly string[];
}) {
  const at = Math.min(Math.max(index, 0), stages.length - 1);
  return (
    <span className="pipe-mini" title={stages[at]}>
      {stages.map((stage, i) => {
        let c = "";
        if (i < at) c = "on";
        else if (i === at) c = state === "failed" ? "bad" : "now";
        return <i className={c} key={stage + i} />;
      })}
    </span>
  );
}
